import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const dummySales = [
  {
    SNo: 1,
    customerName: "Rajesh Kumar",
    phone: "9876543210",
    date: "2025-11-01",
    amount: 120,
  },
  {
    SNo: 2,
    customerName: "Priya Sharma",
    phone: "8765432109",
    date: "2025-11-02",
    amount: 150,
  },
  {
    SNo: 3,
    customerName: "Amit Patel",
    phone: "7654321098",
    date: "2025-12-03",
    amount: 200,
  },
  {
    SNo: 4,
    customerName: "Neha Gupta",
    phone: "6543210987",
    date: "2025-12-04",
    amount: 90,
  },
  {
    SNo: 5,
    customerName: "Vikram Singh",
    phone: "5432109876",
    date: "2025-12-05",
    amount: 300,
  },
  {
    SNo: 6,
    customerName: "Anita Desai",
    phone: "4321098765",
    date: "2025-12-06",
    amount: 400,
  },
  {
    SNo: 7,
    customerName: "Suresh Reddy",
    phone: "3210987654",
    date: "2025-12-07",
    amount: 250,
  },
  {
    SNo: 8,
    customerName: "Meera Joshi",
    phone: "2109876543",
    date: "2025-12-08",
    amount: 180,
  },
  {
    SNo: 9,
    customerName: "Karan Malhotra",
    phone: "1098765432",
    date: "2025-12-09",
    amount: 220,
  },
  {
    SNo: 10,
    customerName: "Ritu Banerjee",
    phone: "9988776655",
    date: "2025-12-10",
    amount: 500,
  },
  {
    SNo: 11,
    customerName: "Deepak Nair",
    phone: "9977665544",
    date: "2025-12-13",
    amount: 500,
  },
];

function getSales(period) {
  const now = new Date();
  if (period === "today") {
    const today = now.toISOString().slice(0, 10);
    return dummySales.filter((s) => s.date === today);
  }
  if (period === "week") {
    const weekAgo = new Date(now);
    weekAgo.setDate(now.getDate() - 6);
    return dummySales.filter(
      (s) => new Date(s.date) >= weekAgo && new Date(s.date) <= now
    );
  }
  if (period === "month") {
    const monthAgo = new Date(now);
    monthAgo.setDate(now.getDate() - 29);
    return dummySales.filter(
      (s) => new Date(s.date) >= monthAgo && new Date(s.date) <= now
    );
  }
  return dummySales; // "total" shows all data
}

export default function Reports() {
  const [tab, setTab] = useState("today");
  const sales = getSales(tab);
  const total = sales.reduce((sum, s) => sum + s.amount, 0);

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(sales);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sales");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([buf], { type: "application/octet-stream" }), "sales.xlsx");
  };

  return (
    <div>
      <h2>Sales Reports</h2>
      <div className="report-tabs">
        <button
          className={tab === "today" ? "active" : ""}
          onClick={() => setTab("today")}
        >
          Today
        </button>
        <button
          className={tab === "week" ? "active" : ""}
          onClick={() => setTab("week")}
        >
          Week
        </button>
        <button
          className={tab === "month" ? "active" : ""}
          onClick={() => setTab("month")}
        >
          Month
        </button>
        <button
          className={tab === "total" ? "active" : ""}
          onClick={() => setTab("total")}
        >
          Total
        </button>
      </div>

      <div className="summary">
        <h3>Total Sales: ₹{total.toLocaleString()}</h3>
        <p>{sales.length} transactions</p>
      </div>

      <table className="sales-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Customer Name</th>
            <th>Phone</th>
            <th>Date</th>
            <th>Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {sales.map((s) => (
            <tr key={s.SNo}>
              <td>{s.SNo}</td>
              <td>{s.customerName}</td>
              <td>{s.phone}</td>
              <td>{s.date}</td>
              <td>₹{s.amount.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="4">
              <b>Total</b>
            </td>
            <td>
              <b>₹{total.toLocaleString()}</b>
            </td>
          </tr>
        </tfoot>
      </table>

      <button className="export-btn" onClick={exportToExcel}>
        📊 Export to Excel
      </button>
    </div>
  );
}
